import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export function initScaleAnimations() {
    const scaleElements = document.querySelectorAll('[data-scale-in]');
    
    scaleElements.forEach((element) => {
        const targetScale = parseFloat(element.dataset.scaleIn) || 1;
        const initialScale = parseFloat(element.dataset.initialScale) || 0.8;
        const duration = parseFloat(element.dataset.duration) || 1;
        const delay = parseFloat(element.dataset.delay) || 0;
        const origin = element.dataset.origin || 'center';
        
        gsap.set(element, { 
            scale: initialScale, 
            opacity: 0,
            transformOrigin: origin
        });
        
        ScrollTrigger.create({
            trigger: element,
            start: "top 80%",
            once: true,
            onEnter: () => {
                gsap.to(element, {
                    scale: targetScale,
                    opacity: 1,
                    duration: duration,
                    delay: delay,
                    ease: "power2.out"
                });
            }
        });
    });
}
